exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".column[data-v-abaf5832]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.chevron[data-v-abaf5832]{color:#0c2340}.row-item-transparent-with-border[data-v-abaf5832]{cursor:pointer}", ""]);

// exports
